import { render } from "./RolesForUserView.vue?vue&type=template&id=16247324&scoped=true&ts=true"
import script from "./RolesForUserView.vue?vue&type=script&lang=ts"
export * from "./RolesForUserView.vue?vue&type=script&lang=ts"

import "./RolesForUserView.vue?vue&type=style&index=0&id=16247324&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16247324"]])

export default __exports__